import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AuthenticationSandbox } from '@app/authentication/sandboxes/authentication.sandbox';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { TransactionSandbox } from '@app/transaction/sandboxes/transaction.sandbox';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-dashboard-services',
    template: `
        <app-card-container>
            <div class="u-container-small u-margin-0-auto">
                <!-- Entrypoint to meter readings,Only show if logged in and has a move -->
                <app-utility-transfer-section *ngIf="showUtilityTransfers$ | async"></app-utility-transfer-section>

                <!-- Selected services -->
                <app-complete-data
                    class="u-display-block u-margin-bottom-triple"
                    *ngIf="showCompletedServices$ | async"
                ></app-complete-data>

                <!-- Non-selected services -->
                <app-major-service-list
                    *ngIf="moveSandbox.showMajorList$ | async"
                    class="u-display-block u-margin-bottom-triple"
                ></app-major-service-list>
                <app-minor-service-list class="u-display-block u-margin-bottom-triple"></app-minor-service-list>

                <!-- Contact -->
                <app-contact-us-wrapper></app-contact-us-wrapper>

                <!-- Footer -->
                <app-general-info-footer></app-general-info-footer>
            </div>
        </app-card-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardServicesComponent implements OnInit {
    private readonly transactionSandbox = inject(TransactionSandbox);
    public readonly authenticationSandbox = inject(AuthenticationSandbox);

    public showUtilityTransfers$: Observable<boolean>;
    public showCompletedServices$: Observable<boolean>;

    constructor(public moveSandbox: MoveSandbox) {}

    public ngOnInit(): void {
        this.transactionSandbox.getTransaction();

        this.showUtilityTransfers$ = combineLatest([this.authenticationSandbox.authorization(), this.moveSandbox.hasAMove$]).pipe(
            map(([user, hasMove]) => !!user && !!hasMove),
        );

        this.showCompletedServices$ = combineLatest([this.moveSandbox.isSomeComplete$, this.moveSandbox.showCompleteData$]).pipe(
            map(([isSomeComplete, showCompleteData]) => !!isSomeComplete || !!showCompleteData),
        );
    }
}
